import React, { FC } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Discount, Price } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { Price as PriceComponent } from '@common/components/Price';
import { toRoomPriceAfterDiscount } from '@features/rooms/helpers/toRoomPriceAfterDiscount.helper';

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.spaces.space1} 0;
  font-weight: normal;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

type PricePerNightProps = {
  checkIn: string;
  checkOut: string;
  roomTotalPrice?: Price;
  discount?: Discount | null;
};

export const PricePerNight: FC<PricePerNightProps> = ({
  checkIn,
  checkOut,
  roomTotalPrice,
  discount,
}) => {
  const { t } = useTranslations();

  if (!roomTotalPrice) {
    return null;
  }

  const numberOfNights = moment(checkOut).diff(moment(checkIn), 'days');
  const { currencyCode, amount: roomAmount } = toRoomPriceAfterDiscount(roomTotalPrice, discount);
  const amount = roomAmount / numberOfNights;

  return (
    <Wrapper>
      {t('room.pricePerNight', {
        pricePerNight: <PriceComponent price={{ currencyCode, amount }} />,
      })}
    </Wrapper>
  );
};
